import { Icon } from '@amigoapp/doca-react';

const LiveKitFileList = ({ files, onRemoveFile }) => (
	<div className="lk-file-list">
		{files.map(file => (
			<div key={file.id} className="lk-file-list__item">
				<span className="lk-file-list__badge">
					<Icon className="lk-file-list__icon" name="file-lines" type="solid" />
				</span>
				<span className="lk-file-list__info">
					<span className="lk-file-list__name">{file.name}</span>
					<span className="lk-file-list__size">{file.sizeLabel}</span>
				</span>
				<Icon className="lk-file-list__remove" name="xmark" type="solid" onClick={() => onRemoveFile(file.id)} />
			</div>
		))}
	</div>
);

export default LiveKitFileList;
